<div class="host-size">
    <input required class="form-control input-sm" type="text" [placeholder]="label" [ngModel]="sizeValue" [disabled]="disabled" (keypress)="numberOnly($event)"
        (input)="formatValue($event.target.value)" />
    <span class="size-format">{{ sizeFormatted }}</span>
</div>
